import React, { useState, useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";
import getSymbolFromCurrency from 'currency-symbol-map'
import { connect } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from "../../components/CustomButtons/Button.js";
import { primaryColor, primaryIconColor } from "../../style.scss";
import { ReactComponent as ConfirmTransactionIcon } from '../../assets/img/journey_transfer.svg'
import formStyle from "../../assets/jss/eclipse/components/formStyle.js";
import Danger from "../../components/Typography/Danger.js";
import { DCustomerManagementApi } from "eclipse-react-sdk/services";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { SpinnerComponent } from "react-element-spinner";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AddCircleOutlineOutlined from '@material-ui/icons/AddCircleOutlineOutlined';
import PaymentIcon from '@material-ui/icons/Payment';
import { CreateVASInputControls, ReturnPartialPaymentAmountAllowed, ValidateVASInputControls } from "../VAS/VASControls.js";
import FormattedAmount from "../../formattedAmount.js";
import { CardStatus } from "../../eclipse-react-sdk/services/models";
import { AmountTextField } from "../../components/Amount/AmountTextField.js";

const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);

export function PayAmount(props) {
  const walletTitleText = props?.appData?.template?.pwaAppOptions?.walletTitleText
  const scannedQRData = useLocation().state?.scannedQRData;
  const wallets = props?.appData?.wallets;
  const fromScreen = useLocation().state?.fromScreen;

  const [linkedBankCards, setLinkedBankCards] = React.useState([]);
  const [isGetLinkBankCard, setGetLinkBankCard] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const defaultPaymentProcess = scannedQRData && scannedQRData?.walletId > 0 && wallets ? 'WALLETS' : 'CARDS';
  const [paymentProcess, setPaymentProcess] = React.useState(defaultPaymentProcess);
  const isPartialPaymentAmountAllowed = ReturnPartialPaymentAmountAllowed(scannedQRData?.partialPaymentAllowed);

  const history = useHistory();
  const classes = useStyles();

  const defaultAmount = (scannedQRData?.amount && scannedQRData?.amount > 0) ? scannedQRData?.amount : 0;
  const [inputs, setInputs] = useState({ fromWalletCard: '', toWallet: scannedQRData?.walletId, amount: defaultAmount > 0 ? defaultAmount : '', ...CreateVASInputControls(scannedQRData?.additionalFields) });
  const [errors, setErrors] = useState({});
  const [alertData, setAlert] = React.useState(null);
  const [pastedAmount, setPastedAmount] = useState(0);

  const onChangeRadio = (event) => {
    setPaymentProcess(event.target.value);
    setInputs({ fromWalletCard: '', toWallet: scannedQRData?.walletId, amount: defaultAmount > 0 ? defaultAmount : '', ...CreateVASInputControls(scannedQRData?.additionalFields) });
    setErrors({});
  };

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }, [history]);

  const handleInputAmountPaste = (event) => {
    event.persist();
    let pastedData = (event.clipboardData || window.clipboardData).getData('text');
    let formattedData = FormattedAmount(pastedData, 'PASTE');
    inputs['amount'] = formattedData;
    if (formattedData > 0) {
      setPastedAmount(inputs?.amount);
    }
    const validationErrors = validateQRForm(inputs);
    setErrors(validationErrors);
  }

  const handleInputChange = (event) => {
    event.persist();
    if (event.target.name === 'amount') {
      if (pastedAmount > 0) {
        inputs['amount'] = pastedAmount;
        setPastedAmount(0);
      } else {
        inputs['amount'] = FormattedAmount(event.target.value);
      }
    } else {
      inputs[event.target.name] = event.target.value;
    }
    setInputs(inputs);
    const validationErrors = validateQRForm();
    setErrors(validationErrors);
  }

  const handleInputKeyUp = (event) => {
    event.persist();
    if (event.key === ',' && event.target.name === 'amount') {
      inputs['amount'] = FormattedAmount(event.target.value);
      setInputs(inputs);
    }
    const validationErrors = validateQRForm();
    setErrors(validationErrors);
  }

  const validateQRForm = () => {
    let errors = {};
    if (!inputs.fromWalletCard) {
      errors.fromWalletCard = paymentProcess === 'WALLETS' ? `From ${walletTitleText?.toLowerCase()} required!` : 'From card required!'
      return errors;
    } else if (!/^[0-9a-zA-Z-]{1,}$/i.test(inputs.fromWalletCard)) {
      errors.fromWalletCard = paymentProcess === 'WALLETS' ? `Invalid from ${walletTitleText?.toLowerCase()}!` : 'Invalid from card!'
      return errors;
    }

    if (isPartialPaymentAmountAllowed) {
      if (scannedQRData?.minAmount && inputs.amount < +scannedQRData?.minAmount) {
        errors.amount = `Invalid Amount! It must be minimum R${scannedQRData?.minAmount}!`;
        return errors;
      }
      if (scannedQRData?.maxAmount && inputs.amount > +scannedQRData?.maxAmount) {
        errors.amount = `Invalid Amount! It must be maximum R${scannedQRData?.maxAmount}!`;
        return errors;
      }
    }

    if (errors && !errors.amount) {
      if (!inputs.amount) {
        errors.amount = 'Amount required!';
        return errors;
      } else if (!/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d{2})?$/i.test(inputs.amount)) {
        errors.amount = 'Invalid amount!'
        return errors;
      } else if (inputs.amount < 1) {
        errors.amount = 'Invalid amount! it must be minimum 1'
        return errors;
      }
    }

    errors = ValidateVASInputControls(inputs, scannedQRData?.additionalFields);
    if (Object.keys(errors).length > 0) {
      return errors;
    }

    return errors;
  }

  const goToManageBankCards = () => {
    history.push({
      pathname: '/pages/manage-linked-cards',
      state: { fromScreen: 'QRSCAN', scannedQRData: scannedQRData, linkedBankCards: linkedBankCards }
    });
  };

  const linkNewBankCard = () => {
    history.push({
      pathname: '/pages/card-on-file',
      state: { fromScreen: 'QRSCAN', scannedQRData: scannedQRData }
    });
  };

  const backToScan = () => {
    history.push({
      pathname: '/pages/pay-qr',
      state: { fromScreen: fromScreen }
    });
  }

  const confirmToQRPay = (inputs) => {
    const selectedWallet = props?.appData?.wallets?.filter(wallet => wallet?.walletId === inputs.fromWalletCard)[0];
    const selectedCard = linkedBankCards?.filter(card => card?.cardOnFileId === inputs.fromWalletCard)[0];
    history.push({
      pathname: '/pages/confirm-pay-amount',
      state: {
        scannedQRData: scannedQRData,
        paymentDetails: inputs,
        walletDetailData: selectedWallet,
        cardDetailData: selectedCard,
        paymentProcess: paymentProcess
      }
    });
  }

  const handleQRFormSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateQRForm();
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      confirmToQRPay(inputs);
    }
  }

  const getLinkedBankCards = useCallback(() => {
    setLoading(true);
    const linkedBankCardsAPI = new DCustomerManagementApi();
    linkedBankCardsAPI.tenantsTenantIdCustomersCustomerIdCardsOnFileGet(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId).then((linkedBankCardsAPIResponse) => {
      setLoading(false);
      if (linkedBankCardsAPIResponse?.data && linkedBankCardsAPIResponse?.data.length > 0) {
        linkedBankCardsAPIResponse.data = linkedBankCardsAPIResponse.data.filter((card => card.status === CardStatus?.ACTIVE))
        setLinkedBankCards(linkedBankCardsAPIResponse.data);
      } else {
        setLinkedBankCards([{ cardOnFileId: '', alias: '', last4Digits: '' }]);
      }
      setGetLinkBankCard(true);
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }, [props, redirectToErrorScreen]);

  React.useEffect(() => {
    if (linkedBankCards.length < 1 && !isGetLinkBankCard) {
      getLinkedBankCards();
    }
    if (paymentProcess === 'CARDS' && linkedBankCards.length === 1) {
      inputs.fromWalletCard = linkedBankCards[0]?.cardOnFileId;
      setInputs(inputs);
    }

  }, [inputs, paymentProcess, linkedBankCards, getLinkedBankCards, isGetLinkBankCard]);

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToScan} />
              <span className={classes.title}>Pay a QR Code</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              <ConfirmTransactionIcon fill={primaryIconColor} stroke={primaryIconColor} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0 m-b-0'}><b>Your about to pay</b></p>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><b>({scannedQRData?.reference})</b></p>
              <h2 style={{ color: primaryIconColor, margin: '0' }} className={classes.textCenter}><b>R{(+inputs?.amount + (inputs?.tipAmount ? +inputs?.tipAmount : 0)).toFixed(2)}</b></h2>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridItem xs={12} sm={12} md={12}>
            <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-b-0'}><b>How would you like to pay?</b></p>
          </GridItem>
          {scannedQRData && scannedQRData?.walletId > 0 && linkedBankCards.length && wallets ?
            <GridItem xs={12} sm={12} md={12}>
              <RadioGroup aria-label="transferType" name="transferType" value={paymentProcess} onChange={onChangeRadio}>
                <FormControlLabel value="WALLETS" control={<Radio />} label={`Use my ${walletTitleText?.toLowerCase()}(s)`} />
                <FormControlLabel value="CARDS" color={primaryColor} control={<Radio className={classes.Radio} />} label="Use linked card(s)" />
              </RadioGroup>
            </GridItem>
            : null}
          <form onSubmit={handleQRFormSubmit}>
            <GridItem xs={12} sm={12} md={12}>
              <ValidationTextField
                fullWidth
                label={paymentProcess === 'WALLETS' ? `From ${walletTitleText?.toLowerCase()}` : "From card"}
                select
                variant="filled"
                id="fromWalletCard"
                type={paymentProcess === 'WALLETS' ? "number" : "text"}
                error={!!(errors.fromWalletCard)}
                name="fromWalletCard"
                value={inputs.fromWalletCard}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyUp}>
                {paymentProcess === 'WALLETS' ?
                  wallets && wallets.length > 0 ?
                    wallets?.map((wallet) => {
                      return (<MenuItem key={wallet?.walletId}
                        value={wallet?.walletId}>{wallet?.name}({getSymbolFromCurrency(wallet?.currency)} {wallet?.availableBalance.toFixed(2)})</MenuItem>)
                    }) : <MenuItem key={""} value={""}>{`No ${walletTitleText?.toLowerCase()} found`}</MenuItem> :
                  linkedBankCards?.map((bankCard) => {
                    return (<MenuItem key={bankCard?.cardOnFileId} value={bankCard?.cardOnFileId}>{bankCard?.alias !== '' && bankCard?.last4Digits !== '' ? bankCard?.alias + ' - **' + bankCard?.last4Digits : 'No card found'}</MenuItem>)
                  })
                }
              </ValidationTextField>
              {errors.fromWalletCard && <Danger><small>{errors.fromWalletCard}</small></Danger>}
              {paymentProcess === 'CARDS' ?
                <div className="external-links" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '10px' }}>
                  <span onClick={linkNewBankCard} style={{ display: 'flex', margin: '0 10px 0 0' }} className={classes.linkColor + ' ' + classes.regularFontSize}><AddCircleOutlineOutlined />&nbsp;<b>Add a card</b></span>
                  <span onClick={goToManageBankCards} style={{ display: 'flex', margin: '0 0 0 10px' }} className={classes.linkColor + ' ' + classes.regularFontSize}><PaymentIcon />&nbsp;<b>Manage my cards</b></span>
                </div>
                : null}
            </GridItem>
            {defaultAmount === 0 || (defaultAmount > 0 && isPartialPaymentAmountAllowed) ?
              <GridItem xs={12} sm={12} md={12}>
                <h6 className={classes.regularFontSize} style={{ margin: '10px 0', textTransform: 'capitalize' }}><b>With how much would you like to pay?</b></h6>
                <AmountTextField
                  {...props?.appData}
                  inputs={inputs}
                  errors={errors}
                  disabled={!(defaultAmount === 0 || (defaultAmount > 0 && isPartialPaymentAmountAllowed))}
                  onPaste={handleInputAmountPaste}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp} />
              </GridItem>
              : null}

            {scannedQRData?.additionalFields?.map((control, index) => {
              return (
                <GridItem xs={12} sm={12} md={12} key={index}>
                  <ValidationTextField
                    fullWidth
                    label={control?.title}
                    variant="filled"
                    id={control?.id}
                    type="text"
                    error={!!(errors[control?.id])}
                    name={control?.id}
                    value={inputs[control?.id]}
                    onChange={handleInputChange}
                    onKeyUp={handleInputKeyUp} />
                  {errors[control?.id] && <Danger><small>{errors[control?.id]}</small></Danger>}
                </GridItem>)
            })}

            <GridItem xs={12} sm={12} md={12}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit" disabled={Object.keys(errors).length !== 0}>Pay now</Button>
            </GridItem>
          </form>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

export default connect(mapStateToProps)(PayAmount)
